export const gte = (x, y) => Number(x) >= Number(y)
